import { CONTACT_INFO } from "@/data/siteData";

export const WhatsAppButton = () => {
  const phoneDigits = CONTACT_INFO.phone.replace(/\D/g, "");
  const message = encodeURIComponent("Hi! I'd like to know more about The Market Place.");

  return (
    <a
      href={`https://wa.me/${phoneDigits}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Message us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/20 flex items-center justify-center hover:scale-110 transition-transform duration-300"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7" fill="white" aria-hidden="true">
        <path d="M16.001 3C9.11 3 3.5 8.61 3.5 15.5c0 2.43.7 4.7 1.9 6.62L3 29l7.09-2.36a12.4 12.4 0 0 0 5.9 1.5h.01c6.89 0 12.5-5.61 12.5-12.5S22.9 3 16.001 3zm0 22.7h-.01a10.2 10.2 0 0 1-5.2-1.43l-.37-.22-3.9 1.3 1.31-3.8-.24-.39a10.2 10.2 0 0 1-1.57-5.46c0-5.65 4.6-10.25 10.28-10.25 2.75 0 5.33 1.07 7.27 3.02a10.2 10.2 0 0 1 3.01 7.24c0 5.65-4.6 10.25-10.28 10.25zm5.62-7.68c-.3-.15-1.8-.89-2.08-.99-.28-.1-.48-.15-.68.15-.2.3-.78.99-.96 1.19-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.66-2.07-.18-.3-.02-.46.13-.61.15-.15.33-.38.5-.57.17-.2.22-.34.33-.57.11-.22.05-.42-.05-.57-.1-.15-.6-1.44-.82-1.98-.22-.53-.44-.46-.61-.47h-.52c-.18 0-.46.07-.7.34-.24.27-.94.92-.94 2.24 0 1.32.96 2.6 1.09 2.78.13.18 1.8 2.75 4.39 3.75 2.59.99 2.59.66 3.06.62.46-.04 1.5-.61 1.71-1.2.22-.59.22-1.1.15-1.2-.06-.11-.24-.18-.53-.32z" />
      </svg>
    </a>
  );
};
